import { gql } from '@apollo/client'

export const UNREAD_NOTIFICATIONS_COUNT_POLL_MS = 5 * 60 * 1000

export const GET_UNREAD_NOTIFICATIONS_COUNT = gql`
  query unreadNotificationsCount {
    unreadNotificationsCount
  }
`

export const GET_NOTIFICATIONS = gql`
  query notifications {
    notifications {
      _id
      orgId
      userId
      action
      actionDateTime
      old
      system
      actionLink
      actionLinkTarget
      attachment
    }
  }
`

export const NOTIFICATION_REFETCH_QUERIES = [
  { query: GET_UNREAD_NOTIFICATIONS_COUNT },
  { query: GET_NOTIFICATIONS },
]
